import React from "react";
import HashLoader from "react-spinners/HashLoader";

const Loading = ({ loading, color, size, height }) => {
  return (
    <div className="loading-container" style={{ height: height && "100vh" }}>
      <HashLoader
        color={color ? color : "#ffffff"}
        loading={loading}
        // cssOverride={override}
        size={size ? size : 20}
        aria-label="Loading Spinner"
        data-testid="loader"
      />
    </div>
  );
};

export default Loading;
